export const cluster = ['mainnet','appspot.com'];